import { GenerateReportQRCodesPopup } from './GenerateReportQRCodesPopup';

export default GenerateReportQRCodesPopup;
